import * as React from 'react'

import { Box, Section } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { automations } from 'modules/automations/store/collections/automations'

import { AutomationsGroup } from './Group'

const AutomationsList = () => {
  const companyAutomations = automations.notDefault

  return (
    <>
      <Section.TwoThirds
        description={i18n.t('automations.index.side_description')}
        illustration="automations"
        title={i18n.t('automations.index.side_title')}
      >
        <Box paddingTop="s4" paddingLeft="s40" gap="s48">
          {!!companyAutomations.length && (
            <AutomationsGroup
              automations={companyAutomations}
              description={i18n.t('automations.company_automations.description')}
              title={i18n.t('automations.company_automations.title')}
            />
          )}
          <AutomationsGroup
            automations={automations.default}
            description={i18n.t('automations.default_automations.description')}
            title={i18n.t('automations.default_automations.title')}
          />
        </Box>
      </Section.TwoThirds>
    </>
  )
}

export default observer(AutomationsList)
